import React from "react";
import "../assets/styles/components/Caracteristiques.css";
import caracteristiques from "../data/Caracteristiques";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const CaracteristiquesCarousel = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 4, // Nombre de caractéristiques à afficher sur grand écran
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 3, // Nombre de caractéristiques à afficher sur bureau
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2, // Nombre de caractéristiques à afficher sur tablette
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1, // Nombre de caractéristiques à afficher sur mobile
    },
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Caractéristiques</h2>
      <Carousel
        responsive={responsive}
        infinite={true} // Boucle infinie
        autoPlay={true} // Lecture automatique
        autoPlaySpeed={3000} // Vitesse de lecture automatique (3 secondes)
        transitionDuration={500} // Durée de transition (500ms)
        arrows={true} // Affiche les flèches de navigation
      >
        {caracteristiques.map((item) => (
          <div key={item.id} className="text-center p-3">
            <FontAwesomeIcon icon={item.icon} className="mb-2 violet-foncee" size="2x" />
            <h3>{item.name}</h3>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CaracteristiquesCarousel;
